import AudioCubeApiCallerInstance from "../utils/AudioCubeApiCallerInstance";
import { SOUNDBOX_API_ENDPOINTS } from "../URLConstants";

export const CreateOrganization = async(name,slug,email,countryCode,phone,address,status,image)=>{
        const response = await AudioCubeApiCallerInstance.post(SOUNDBOX_API_ENDPOINTS.CREATE_ORGANIZATION,{
                "name": name,
                "slug":slug,
                "email":email,
                "countryCode":countryCode,
                "phone":phone,
                "image":image,
                "address":address,
                "status":status
        })
        return response;
    
}

export const GetAllOrganinazations = async(pageNo,limit)=>{
        const response = await AudioCubeApiCallerInstance.get(`${SOUNDBOX_API_ENDPOINTS.GET_ORGANIZATION_LIST}?page=${pageNo}&limit=${limit}`)
        return response;
}

export const CreateUserInOrganization = async(organizationId,name,email,password,phone,role,zone,image)=>{
        const response = await AudioCubeApiCallerInstance.post(SOUNDBOX_API_ENDPOINTS.CREATE_USER_IN_ORGANIZATION,{
                "email": email,
                "password": password,
                "organizationId": organizationId,
                "name": name,
                "phone": phone,
                "role": role,
                "zonePath": zone,
                "image": image
            
        })
        return response;
   
}

export const UpdateUserInOrganization = async(userId,payload)=>{
        const response = await AudioCubeApiCallerInstance.patch(`${SOUNDBOX_API_ENDPOINTS.CREATE_USER_IN_ORGANIZATION}/${userId}`,payload)
        return response;
   
}


export const GetOrganizationDetailsById=async(organizationId)=>{
        const response = await AudioCubeApiCallerInstance.get(`${SOUNDBOX_API_ENDPOINTS.GET_ORGANIZATION_LIST}/${organizationId}`)
        return response;
}
export const SetupOrganizationConfig=async(organizationId,offlineCheckDuration,allowNoOfTriggers)=>{
        const response = await AudioCubeApiCallerInstance.post(SOUNDBOX_API_ENDPOINTS.SETUP_ORGANIZATION_CONFIG,{
                "organizationId": organizationId,
                "offline_check_duration": offlineCheckDuration,
                // "allow_number_of_trigger_in_day": allowNoOfTriggers,
            
        })
        return response;
}

export const GetAllOrganinazationUser = async(pageNo,limit,organizationId)=>{
    const response = await AudioCubeApiCallerInstance.get(`${SOUNDBOX_API_ENDPOINTS.CREATE_USER_IN_ORGANIZATION}?page=${pageNo}&limit=${limit}&showDeleted=true`,{
        params:{
                "where":JSON.stringify({"organizationId":organizationId})
        }
    })
    return response;
}

export const GetOrganizationMerchantStats= (organizationId)=>{

        const response =  AudioCubeApiCallerInstance.post(SOUNDBOX_API_ENDPOINTS.DASHBOARD_STATS,{
                "organizationId": organizationId,
        })
        return response;
}

export const GetAllOrganizationMerchantStatsAsSuperAdmin= async()=>{

        const response = await AudioCubeApiCallerInstance.post(SOUNDBOX_API_ENDPOINTS.DASHBOARD_STATS)
        return response;
}

export const GetOrganizationTransactionStats= (organizationId,fromDate,toDate)=>{

        const response =  AudioCubeApiCallerInstance.post(SOUNDBOX_API_ENDPOINTS.TRANSACTION_STATS,{
                "organizationId": organizationId,
                "from_date"     : fromDate,
                "to_date"     :    toDate
        })
        return response;
}

export const GetTransactionHistory=(pageNo,limit,where,startDate,endDate)=>{


        const response =  AudioCubeApiCallerInstance.get(`${SOUNDBOX_API_ENDPOINTS.TRANSATION_LIST}?limit=${limit}&page=${pageNo}&startDate=${startDate}&endDate=${endDate}`,{
                params:{
                        "where":JSON.stringify(where)
                }
        })
        return response;




}

export const OrganizationBranchesBulkUpload = async (file,organizationId) => {

        const formData = new FormData();
        formData.append("file", file);
        formData.append("organizationId",organizationId)
        const response = await AudioCubeApiCallerInstance.post(SOUNDBOX_API_ENDPOINTS.ORG_BRANCHES_BULK_UPLOAD, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        })

        return response
       
}

export const GetOrganizationNotifications=(organizationId,pageNo,limit)=>{

        const response =  AudioCubeApiCallerInstance.post(`${SOUNDBOX_API_ENDPOINTS.NOTIFICATION_HISTORY}?page=${pageNo}&limit=${limit}&masked=false`,{
                "organizationId": organizationId,
               
        })
        return response;
}


export const DeActiveOrganizationUsers=(organizationId,userId)=>{

        const response =  AudioCubeApiCallerInstance.delete(`${SOUNDBOX_API_ENDPOINTS.CREATE_USER_IN_ORGANIZATION}/${userId}`)
        return response;
}

export const ReActivateOrganizationUsers=(organizationId,userId)=>{

        const response =  AudioCubeApiCallerInstance.post(`${SOUNDBOX_API_ENDPOINTS.REACTIVATE_USER_IN_ORGANIZATION}/${userId}`)
        return response;
}
